const MainNavigationTab = ({ title, children, newIcon }) => (
  <div className="mainNavigationTab">
    {children}
    <span className="mainNavigationTabTitle">{title}</span>
    {newIcon}
  </div>
);

export default MainNavigationTab;
